"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var DEFAULT_BREAKPOINT_NAME = exports.DEFAULT_BREAKPOINT_NAME = "default";

var LT_MODIFIER = exports.LT_MODIFIER = "<";
var GT_MODIFIER = exports.GT_MODIFIER = ">";
var AT_MODIFIER = exports.AT_MODIFIER = "@";
var MODIFIERS = exports.MODIFIERS = [LT_MODIFIER, GT_MODIFIER, AT_MODIFIER];
var POSITIVE_OFFSET = exports.POSITIVE_OFFSET = "+";
var NEGATIVE_OFFSET = exports.NEGATIVE_OFFSET = "-";
var OFFSETS = exports.OFFSETS = [POSITIVE_OFFSET, NEGATIVE_OFFSET];


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/breakpoints.js
// module id = 173
// module chunks = 168707334958949